import React from 'react';
import {AutoField, Text} from '../../fields';
import Section from 'components/forms/Section';
import {Typography} from '@material-ui/core';
import fields from 'components/forms/noaatoss/fields';
import {getInitialValues, getSchema} from 'components/forms/AutoSection';
//import {useFieldData} from 'components/forms/hooks';

const ShipmentDischarge = props => {
    //const vesselName = useFieldData('vessel_name');
    const fieldDict = fields;
    const sectionFields = [
        'date_reported',
        'date_detached',
        'deck_position_served',
        'department',
    ];
    const schema = getSchema(sectionFields, fieldDict);
    const initialValues = getInitialValues({}, sectionFields, fieldDict);

    return (
        <Section {...props} schema={schema} initialValues={initialValues}>
            <Typography variant='h6' align='left'>
                Dates
            </Typography>
            <Typography variant='body1' align='left'>
                {/* TODO: make vessel_name dynamic */}
                Now tell us about the dates you were on this vessel and the positions
                you served.
            </Typography>
            <Typography variant='body1' align='left'>
                {/* TODO: [MS-541] make this change based on how many passes you have made... */}
                Start by entering the dates for your first record on this vessel!
            </Typography>
            <AutoField field={fields['date_reported']} name='date_reported' />
            <AutoField field={fields['date_detached']} name='date_detached' />
            <AutoField
                field={fields['deck_position_served']}
                name='deck_position_served'
            />

            <Text hidden field={fields['department']} name='department' />
            <Typography variant='body1' align='left'>
                Don't worry if you have several records on the same vessel on your
                letter - you'll have an opportunity to enter each one.
            </Typography>
            {props.children}
        </Section>
    );
};

export default ShipmentDischarge;
